import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { HttpService } from 'src/service/http.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'octa';
  userActivity;
  userInactive: Subject<any> = new Subject();
  constructor(private router: Router, private httpService: HttpService,
  ) {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      localStorage.clear();
      this.router.navigate(['sign-in']);
    }
      //alert('user has been inactive for 3s')
    );
    // this.httpService.checkIpAddress().subscribe(data=>{
    //   console.log(data);
    // const iPAddress = this.httpService.restrictedIpAddress;
    // console.log(iPAddress)
    // iPAddress.forEach(ip=>{
    //   if(ip != data.ip){
    //     // alert('Hii')
    //     this.router.navigate(['/access-restriction'])
    //   } 
    // })

    // },err=>{

    // })

    const role = localStorage.getItem('roleName')
    //   if () {
    //     const firstLogin = JSON.parse(localStorage.getItem('firstLogin'));
    //     console.log(firstLogin);
    //     if (firstLogin == true) {
    //       this.router.navigate(['/change-password']);
    //     }
    //     this.companyProfileService.companyStatus();

    // }

    // if(Number(roleid) == 2){
    //   this.router.navigate(['challan-list'])
    // }
    // if(Number(roleid) == 9){
    //   this.router.navigate(['create-batch'])
    // }
    // else
    // {
    //   if(Number(roleid) == 4){
    //     this.router.navigate(['add-user'])
    //   } 
    // }
    if (role && role != null) {
      if (role == 'SUPER ADMIN') {
        this.router.navigate(['/super-admin/add-user']);

      } else if (role == 'DATA ENTRY OPERATOR') {
        this.router.navigate(['/data-entry-challan-list'])
      } else if (role === 'IMPORT IN-CHARGE') {
        this.router.navigate(['/importincharge'])
      } else if (role === 'SAMPLE ASSISTANT') {
        this.router.navigate(['/sample-assistant'])
      }
      else if (role === 'LAB RECEIVER') {
        this.router.navigate(['/lab-receiver'])
      } else if (role === 'LAB ADMIN') {
        this.router.navigate(['/lab-admin'])
      }
      else if (role === 'LAB ANALYST') {
        this.router.navigate(['/lab-analyst'])
      } else if (role === 'LAB ACE') {
        this.router.navigate(['/lab-ace'])

      } else if (role === 'ASSISTANT IMPORT IN-CHARGE') {
        this.router.navigate(['/ass-Import-Incharge'])

      }
      else {
        this.router.navigate(['/verifier'])
      }
    }
  }
  ngOnInit(): void {


    this.httpService.getIPAddress().subscribe(address => {

      this.httpService.IPWhitelist({
        "_ip": address['ip'],
        "_userId": localStorage.getItem("uuid")
      }).subscribe(result => {
        if (result && result.responseCode === 0) {
          localStorage.setItem('isIP', 'yes')
        } else {
          localStorage.setItem('isIP', 'no')
        }

      })
    })


  }
  addSecurityHeaders() {
    const headers = new HttpHeaders({
      'X-Frame-Options': 'SAMEORIGIN',
      'Content-Security-Policy': "frame-ancestors 'self'",
      'X-Content-Type-Options': 'nosniff',
      'X-XSS-Protection': '1; mode=block'
    });
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Security-Policy');
    meta.setAttribute('content', "frame-ancestors 'self'");
    document.head.appendChild(meta);
  }






  setTimeout() {
    const Hour = 60 * 60 * 1000;
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), Hour);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

}
